{
  "info": "Info",
  "negative": "Feil",
  "positive": "Vellykket"
}
